import { useListConsumerStudents } from '@givebacks/api/student';
import { useNavigate } from 'react-router-dom';
import { LoadingOverlay, Stack } from 'ui';

import { StudentDisplayCard } from '../components/molecules/cards/StudentDisplayCard';

const StudentsList = () => {
  const navigate = useNavigate();
  const { data: data } = useListConsumerStudents({
    enabled: true,
  });

  if (!data?.students) {
    return <LoadingOverlay visible />;
  }

  return (
    <Stack>
      {data?.students.map((student) => (
        <StudentDisplayCard
          key={student.uuid}
          student={student}
          onClick={() => navigate(`/student-fees/students/${student.uuid}`)}
        />
      ))}
    </Stack>
  );
};

export { StudentsList };
